//=============================================================================
// Attention! This file is generated
//   by /home/timstraube/Programme/Spinnax/freak/freak/freak_tools/src/freak_tools/_com.py
// Only edit within the protected regions!
//=============================================================================

/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/no-unused-vars */

//-----------------------------------------------------------------------------
export class Header {
    packet_id: number = 0;
    reserved_1: number = 0;
    reserved_2: number = 0;
    reserved_3: number = 0;

    constructor() {
        this.packet_id = 0;
        this.reserved_1 = 0;
        this.reserved_2 = 0;
        this.reserved_3 = 0;
        // PR_BEG Header_constructor
        // PR_END
    }

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('Header: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 4;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index: number = 0): Header {
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new Header();
        // packet_id
        if( ! Header._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        instance.packet_id = dataView.getUint8(indexCur);
        indexCur += 1;
        // reserved_1
        if( ! Header._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        instance.reserved_1 = dataView.getUint8(indexCur);
        indexCur += 1;
        // reserved_2
        if( ! Header._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        instance.reserved_2 = dataView.getUint8(indexCur);
        indexCur += 1;
        // reserved_3
        if( ! Header._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        instance.reserved_3 = dataView.getUint8(indexCur);
        indexCur += 1;
        return instance;
    }

    toArrayBuffer( buffer: ArrayBuffer, index: number = 0 ): ArrayBuffer {
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // packet_id
        if( ! Header._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setUint8(indexCur, this.packet_id);
        indexCur += 1;
        // reserved_1
        if( ! Header._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setUint8(indexCur, this.reserved_1);
        indexCur += 1;
        // reserved_2
        if( ! Header._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setUint8(indexCur, this.reserved_2);
        indexCur += 1;
        // reserved_3
        if( ! Header._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setUint8(indexCur, this.reserved_3);
        indexCur += 1;
        return buffer;        
    }
}

export class RecordSample {
    t_ms: number = 0;
    prs_kPa: number = 0.0;
    tmp_deg_C: number = 0.0;
    q_r: number = 0.0;
    q_i: number = 0.0;
    q_j: number = 0.0;
    q_k: number = 0.0;
    acc_u_ms2: number = 0.0;
    acc_v_ms2: number = 0.0;
    acc_w_ms2: number = 0.0;
    omg_u_rads: number = 0.0;
    omg_v_rads: number = 0.0;
    omg_w_rads: number = 0.0;
    mgn: number = 0.0;

    constructor() {
        this.t_ms = 0;
        this.prs_kPa = 0.0;
        this.tmp_deg_C = 0.0;
        this.q_r = 0.0;
        this.q_i = 0.0;
        this.q_j = 0.0;
        this.q_k = 0.0;
        this.acc_u_ms2 = 0.0;
        this.acc_v_ms2 = 0.0;
        this.acc_w_ms2 = 0.0;
        this.omg_u_rads = 0.0;
        this.omg_v_rads = 0.0;
        this.omg_w_rads = 0.0;
        this.mgn = 0.0;
        // PR_BEG RecordSample_constructor
        // PR_END
    }

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('RecordSample: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 56;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index: number = 0): RecordSample {
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new RecordSample();
        // t_ms
        if( ! RecordSample._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        instance.t_ms = dataView.getUint32(indexCur, true);
        indexCur += 4;
        // prs_kPa
        if( ! RecordSample._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        instance.prs_kPa = dataView.getFloat32(indexCur, true);
        indexCur += 4;
        // tmp_deg_C
        if( ! RecordSample._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        instance.tmp_deg_C = dataView.getFloat32(indexCur, true);
        indexCur += 4;
        // q_r
        if( ! RecordSample._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        instance.q_r = dataView.getFloat32(indexCur, true);
        indexCur += 4;
        // q_i
        if( ! RecordSample._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        instance.q_i = dataView.getFloat32(indexCur, true);
        indexCur += 4;
        // q_j
        if( ! RecordSample._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        instance.q_j = dataView.getFloat32(indexCur, true);
        indexCur += 4;
        // q_k
        if( ! RecordSample._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        instance.q_k = dataView.getFloat32(indexCur, true);
        indexCur += 4;
        // acc_u_ms2
        if( ! RecordSample._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        instance.acc_u_ms2 = dataView.getFloat32(indexCur, true);
        indexCur += 4;
        // acc_v_ms2
        if( ! RecordSample._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        instance.acc_v_ms2 = dataView.getFloat32(indexCur, true);
        indexCur += 4;
        // acc_w_ms2
        if( ! RecordSample._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        instance.acc_w_ms2 = dataView.getFloat32(indexCur, true);
        indexCur += 4;
        // omg_u_rads
        if( ! RecordSample._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        instance.omg_u_rads = dataView.getFloat32(indexCur, true);
        indexCur += 4;
        // omg_v_rads
        if( ! RecordSample._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        instance.omg_v_rads = dataView.getFloat32(indexCur, true);
        indexCur += 4;
        // omg_w_rads
        if( ! RecordSample._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        instance.omg_w_rads = dataView.getFloat32(indexCur, true);
        indexCur += 4;
        // mgn
        if( ! RecordSample._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        instance.mgn = dataView.getFloat32(indexCur, true);
        indexCur += 4;
        return instance;
    }

    toArrayBuffer( buffer: ArrayBuffer, index: number = 0 ): ArrayBuffer {
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // t_ms
        if( ! RecordSample._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setUint32(indexCur, this.t_ms, true);
        indexCur += 4;
        // prs_kPa
        if( ! RecordSample._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setFloat32(indexCur, this.prs_kPa, true);
        indexCur += 4;
        // tmp_deg_C
        if( ! RecordSample._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setFloat32(indexCur, this.tmp_deg_C, true);
        indexCur += 4;
        // q_r
        if( ! RecordSample._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setFloat32(indexCur, this.q_r, true);
        indexCur += 4;
        // q_i
        if( ! RecordSample._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setFloat32(indexCur, this.q_i, true);
        indexCur += 4;
        // q_j
        if( ! RecordSample._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setFloat32(indexCur, this.q_j, true);
        indexCur += 4;
        // q_k
        if( ! RecordSample._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setFloat32(indexCur, this.q_k, true);
        indexCur += 4;
        // acc_u_ms2
        if( ! RecordSample._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setFloat32(indexCur, this.acc_u_ms2, true);
        indexCur += 4;
        // acc_v_ms2
        if( ! RecordSample._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setFloat32(indexCur, this.acc_v_ms2, true);
        indexCur += 4;
        // acc_w_ms2
        if( ! RecordSample._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setFloat32(indexCur, this.acc_w_ms2, true);
        indexCur += 4;
        // omg_u_rads
        if( ! RecordSample._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setFloat32(indexCur, this.omg_u_rads, true);
        indexCur += 4;
        // omg_v_rads
        if( ! RecordSample._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setFloat32(indexCur, this.omg_v_rads, true);
        indexCur += 4;
        // omg_w_rads
        if( ! RecordSample._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setFloat32(indexCur, this.omg_w_rads, true);
        indexCur += 4;
        // mgn
        if( ! RecordSample._check( indexCur + 4, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setFloat32(indexCur, this.mgn, true);
        indexCur += 4;
        return buffer;        
    }
}

export class DongleState {
    version_os_major: number = 0;
    version_os_minor: number = 0;
    version_os_patch: number = 0;
    version_os_build: number = 0;
    version_fw_major: number = 0;
    version_fw_minor: number = 0;
    version_fw_patch: number = 0;
    version_fw_build: number = 0;
    debug_not_release: number = 0;
    status_usb: number = 0;
    status_ble: number = 0;
    status_bno08x: number = 0;
    status_dps310: number = 0;
    status_led: number = 0;
    status_button: number = 0;
    status_battery: number = 0;
    fsm_state: number = 0;
    battery_level: number = 0;

    constructor() {
        this.version_os_major = 0;
        this.version_os_minor = 0;
        this.version_os_patch = 0;
        this.version_os_build = 0;
        this.version_fw_major = 0;
        this.version_fw_minor = 0;
        this.version_fw_patch = 0;
        this.version_fw_build = 0;
        this.debug_not_release = 0;
        this.status_usb = 0;
        this.status_ble = 0;
        this.status_bno08x = 0;
        this.status_dps310 = 0;
        this.status_led = 0;
        this.status_button = 0;
        this.status_battery = 0;
        this.fsm_state = 0;
        this.battery_level = 0;
        // PR_BEG DongleState_constructor
        // PR_END
    }

    static _check(n: number, e: number): boolean {
        if( n > e ) {
            console.log('DongleState: Buffer overflow')
            return false;
        }
        return true;
    }

    static byteCount(): number {
        return 18;
    }

    static isUnbounded(): boolean {
        return false;
    }

    static ofArrayBuffer(buffer: ArrayBuffer, index: number = 0): DongleState {
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        const instance = new DongleState();
        // version_os_major
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        instance.version_os_major = dataView.getUint8(indexCur);
        indexCur += 1;
        // version_os_minor
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        instance.version_os_minor = dataView.getUint8(indexCur);
        indexCur += 1;
        // version_os_patch
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        instance.version_os_patch = dataView.getUint8(indexCur);
        indexCur += 1;
        // version_os_build
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        instance.version_os_build = dataView.getUint8(indexCur);
        indexCur += 1;
        // version_fw_major
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        instance.version_fw_major = dataView.getUint8(indexCur);
        indexCur += 1;
        // version_fw_minor
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        instance.version_fw_minor = dataView.getUint8(indexCur);
        indexCur += 1;
        // version_fw_patch
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        instance.version_fw_patch = dataView.getUint8(indexCur);
        indexCur += 1;
        // version_fw_build
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        instance.version_fw_build = dataView.getUint8(indexCur);
        indexCur += 1;
        // debug_not_release
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        instance.debug_not_release = dataView.getUint8(indexCur);
        indexCur += 1;
        // status_usb
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        instance.status_usb = dataView.getUint8(indexCur);
        indexCur += 1;
        // status_ble
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        instance.status_ble = dataView.getUint8(indexCur);
        indexCur += 1;
        // status_bno08x
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        instance.status_bno08x = dataView.getUint8(indexCur);
        indexCur += 1;
        // status_dps310
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        instance.status_dps310 = dataView.getUint8(indexCur);
        indexCur += 1;
        // status_led
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        instance.status_led = dataView.getUint8(indexCur);
        indexCur += 1;
        // status_button
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        instance.status_button = dataView.getUint8(indexCur);
        indexCur += 1;
        // status_battery
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        instance.status_battery = dataView.getUint8(indexCur);
        indexCur += 1;
        // fsm_state
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        instance.fsm_state = dataView.getUint8(indexCur);
        indexCur += 1;
        // battery_level
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        instance.battery_level = dataView.getUint8(indexCur);
        indexCur += 1;
        return instance;
    }

    toArrayBuffer( buffer: ArrayBuffer, index: number = 0 ): ArrayBuffer {
        const dataView = new DataView(buffer);
        let indexCur = index;
        const indexEnd = buffer.byteLength;
        // version_os_major
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setUint8(indexCur, this.version_os_major);
        indexCur += 1;
        // version_os_minor
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setUint8(indexCur, this.version_os_minor);
        indexCur += 1;
        // version_os_patch
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setUint8(indexCur, this.version_os_patch);
        indexCur += 1;
        // version_os_build
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setUint8(indexCur, this.version_os_build);
        indexCur += 1;
        // version_fw_major
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setUint8(indexCur, this.version_fw_major);
        indexCur += 1;
        // version_fw_minor
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setUint8(indexCur, this.version_fw_minor);
        indexCur += 1;
        // version_fw_patch
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setUint8(indexCur, this.version_fw_patch);
        indexCur += 1;
        // version_fw_build
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setUint8(indexCur, this.version_fw_build);
        indexCur += 1;
        // debug_not_release
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setUint8(indexCur, this.debug_not_release);
        indexCur += 1;
        // status_usb
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setUint8(indexCur, this.status_usb);
        indexCur += 1;
        // status_ble
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setUint8(indexCur, this.status_ble);
        indexCur += 1;
        // status_bno08x
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setUint8(indexCur, this.status_bno08x);
        indexCur += 1;
        // status_dps310
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setUint8(indexCur, this.status_dps310);
        indexCur += 1;
        // status_led
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setUint8(indexCur, this.status_led);
        indexCur += 1;
        // status_button
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setUint8(indexCur, this.status_button);
        indexCur += 1;
        // status_battery
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setUint8(indexCur, this.status_battery);
        indexCur += 1;
        // fsm_state
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setUint8(indexCur, this.fsm_state);
        indexCur += 1;
        // battery_level
        if( ! DongleState._check( indexCur + 1, indexEnd) ) {
            throw new RangeError();
        }
        dataView.setUint8(indexCur, this.battery_level);
        indexCur += 1;
        return buffer;        
    }
}
